// extracted by mini-css-extract-plugin
module.exports = {"sparkline":"Sparkline-module--sparkline--19ASi","sparkcircle":"Sparkline-module--sparkcircle--kR469"};